import { isPresent } from './helpers';

/**
 * Internal class to handle promise timeout
 */
export class PromiseResolver {
    
    private _resolve: (value: any) => void;
    private _reject: (reason: Error) => void;
    private _timeOutHandle: number;
    private _isComplete: boolean = false;

    /**
     * constructor
     * @param resolve - resolve function
     * @param reject - reject function
     * @param timeoutValue - timeout value before promise is rejected
     * @param timeoutFunc - timeout function to handle whether the promise should be resolved or rejected
     */
    constructor(
        resolve: (value: any) => void, 
        reject: (reason: Error) => void, 
        timeoutValue?: number,
        timeoutFunc?: (value: PromiseResolver) => void) {

        this._resolve = resolve;
        this._reject = reject;
        if (isPresent(timeoutFunc)) {
            timeoutValue = timeoutValue || 10000;
            this._timeOutHandle = setTimeout(() => {
                timeoutFunc(this); // resolve/reject is handled by timeoutFunc
            }, timeoutValue);
        } else if (isPresent(timeoutValue) && timeoutValue > 0) {
            this._timeOutHandle = setTimeout(() => {
                this._timeOutHandle = null;
                this.reject(new Error('Timeout value reached'));
            }, timeoutValue)
        }
    }

    /**
     * resolve promise and marks promise as complete (clears timeout if set)
     * @param value 
     */
    public resolve(value: any): void {
        if (this.isComplete) return;

        if (isPresent(this._timeOutHandle)) {
            clearTimeout(this._timeOutHandle);
            this._timeOutHandle = null;
        }
        this._isComplete = true;
        this._resolve(value);
    }
    
    /**
     * reject promise and marks promise as complete (clears timeout if set)
     * @param reason 
     */
    public reject(reason: Error): void {
        if (this.isComplete) return;

        if (isPresent(this._timeOutHandle)) {
            clearTimeout(this._timeOutHandle);
            this._timeOutHandle = null;
        }
        this._isComplete = true;
        this._reject(reason);
    }

    /**
     * Returns true if promise has already been resolved or rejected
     */
    get isComplete(): boolean {
        return this._isComplete;
    }
}
    


// WEBPACK FOOTER //
// ./src/promiseResolver.ts